import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enChat from './locales/en/chat.json';
import enTransactions from './locales/en/transactions.json';
import enInvoices from './locales/en/invoices.json';
import enBills from './locales/en/bills.json';
import enGoals from './locales/en/goals.json';
import enBudget from './locales/en/budget.json';
import enSettings from './locales/en/settings.json';
import enAccessibility from './locales/en/accessibility.json';
import enBusinessPlan from './locales/en/businessPlan.json';
import enProductAnalytics from './locales/en/productAnalytics.json';
import enCheckout from './locales/en/checkout.json';


// Import Spanish translations
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esDashboard from './locales/es/dashboard.json';
import esChat from './locales/es/chat.json';
import esTransactions from './locales/es/transactions.json';
import esInvoices from './locales/es/invoices.json';
import esBills from './locales/es/bills.json';
import esGoals from './locales/es/goals.json';
import esBudget from './locales/es/budget.json';
import esSettings from './locales/es/settings.json';
import esAccessibility from './locales/es/accessibility.json';
import esBusinessPlan from './locales/es/businessPlan.json';
import esProductAnalytics from './locales/es/productAnalytics.json';
import esCheckout from './locales/es/checkout.json';


// Read saved language preference from localStorage so the first render
// is immediately in the correct language. Falls back to 'en' if not set
// or if localStorage is unavailable (SSR / service worker context).
const savedLanguage: 'en' | 'es' = (() => {
  try {
    const stored = localStorage.getItem('pulse-language');
    return stored === 'es' ? 'es' : 'en';
  } catch {
    return 'en';
  }
})();

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    chat: enChat,
    transactions: enTransactions,
    invoices: enInvoices,
    bills: enBills,
    goals: enGoals,
    budget: enBudget,
    settings: enSettings,
    accessibility: enAccessibility,
    businessPlan: enBusinessPlan,
    productAnalytics: enProductAnalytics,
    checkout: enCheckout,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    chat: esChat,
    transactions: esTransactions,
    invoices: esInvoices,
    bills: esBills,
    goals: esGoals,
    budget: esBudget,
    settings: esSettings,
    accessibility: esAccessibility,
    businessPlan: esBusinessPlan,
    productAnalytics: esProductAnalytics,
    checkout: esCheckout,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Start with saved language so first render is correct
    fallbackLng: 'en', // Fallback to English if translation missing
    defaultNS: 'common', // Default namespace
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
